import { cn } from '@/lib/utils';

/*
 * The Ardealy mark as a loader: its three pieces arrive one after another,
 * then breathe in a wave (see `.ardealy-loader` in index.css). Drawn inline in
 * currentColor so it follows the theme, which the mark's .svg file cannot.
 */
const PIECES = [
  '519.26 137.53 244.88 137.53 244.59 137.24 244.59 137.53 137.29 137.53 137.29 274.89 137.12 275.07 137.29 275.07 137.29 549.12 .55 412.38 0 0 137.29 0 137.29 .29 137.46 .12 137.58 0 381.93 0 519.26 137.53',
  '657.31 .65 657.31 137.53 519.59 137.53 519.49 0 657.31 .65',
  '657.31 548.78 656.78 274.72 519.59 137.53 519.49 412.02 382.25 412.38 382.25 275.07 244.71 275.07 244.71 411.83 244.9 412.02 245.26 412.38 382.2 549.31 382.25 549.26 382.25 549.36 657.31 548.78',
];

interface ArdealyLoaderProps {
  className?: string;
}

export const ArdealyLoader = ({ className }: ArdealyLoaderProps) => (
  <svg
    viewBox="0 0 657.31 549.36"
    role="status"
    aria-label="Loading"
    className={cn('ardealy-loader text-foreground', className)}
  >
    {PIECES.map((points) => (
      <polygon key={points} points={points} fill="currentColor" />
    ))}
  </svg>
);
